import React from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'
import { CreatableSelect } from '../../../../components/FormBuilder'
import { IStore } from '../../../../reducers'
import { getProvenancesWithInitial } from '../../../../reducers/provenances/selectors/getProvenances'
import sanitizeInput from '../../../../utils/InputFiltering'

const CreatableSelectWithProvenances = ({ provenances, ...rest }: any) => {
  const isValidCreateOption = value => {
    const sanitized = sanitizeInput(
      value
        .replace(
          /([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
          '',
        )
        .trim(),
    )
    return !isEmpty(sanitized) && !provenances.some(p => p.name === sanitized)
  }

  return (
    <CreatableSelect.ReduxField
      {...rest}
      isValidCreateOption={isValidCreateOption}
    >
      {provenances !== undefined &&
        provenances.map(provenance => (
          <CreatableSelect.Option
            key={`provenance-select-${provenance.id}-${provenance.name}`}
            value={provenance.name}
          >
            {provenance.name}
          </CreatableSelect.Option>
        ))}
    </CreatableSelect.ReduxField>
  )
}

export default connect((state: IStore) => ({
  provenances: getProvenancesWithInitial(state),
}))(withTranslation()(CreatableSelectWithProvenances))
